// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__31leH"};